import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-lg-column align-items-lg-start align-items-center justify-content-center"
}
const _hoisted_2 = { class: "pe-2 d-block m-0 text-muted" }
const _hoisted_3 = { class: "text-uppercase fw-bold" }

import AppSelectCard from '@/components/AppSelectCard.vue'
import { locationService } from '@/services/location.service'
import ThePageContainer from '@/components/containers/ThePageContainer.vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { key } from '@/setup/store'
import { VuexStore } from '@/interfaces/VuexStore'
import { CardInterface } from '@/interfaces/CardInterface'
import { useRoute, useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'Ubicaciones',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const { commit } = useStore<VuexStore>(key)
const { t } = useI18n()
const { state } = useStore<VuexStore>(key)

const completeSelection = (data: CardInterface) => {
  router.push({ name: 'DetailUbicaciones', params: { id: data.id } })
  commit('COMPLETE_UBICACION', data)
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(ThePageContainer, null, {
    title: _withCtx(() => [
      (!_unref(state).evento?.fidelizacion)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h6", _hoisted_2, " 1. " + _toDisplayString(_unref(t)('titles.ubicacion.Stitle')), 1),
            _createElementVNode("h2", _hoisted_3, _toDisplayString(!_unref(state).evento?.fidelizacion ? _unref(t)('titles.ubicacion.ubi') : 'Categorias'), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    selector: _withCtx(() => [
      _createVNode(AppSelectCard, {
        service: _unref(locationService),
        class: "d-flex justify-content-start justify-content-lg-center flex-row flex-lg-column gx-0 p-0 p-lg-3",
        routeName: "DetailUbicaciones",
        primaryNavigation: true,
        onCallback: completeSelection,
        preselect: _unref(route).params?.id
      }, null, 8, ["service", "preselect"])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }))
}
}

})